import { format as formatFn } from 'date-fns/format'

export const formatDate = (date: Date | string | undefined, format = 'dd.MM.yyyy') => {
  return typeof date !== 'undefined' ? formatFn(new Date(date), format) : ''
}

export const generateId = (prefix = '', length = 6) => {
  let result = ''
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length)
    result += characters.charAt(randomIndex)
  }

  return prefix + result
}

export const formatSecureValue = (string = '') => {
  let result = string.slice(0, 2)
  const numbOfAsterisk = 16 - Math.min(string.length, 3)

  for (let i = 0; i < numbOfAsterisk; i++) {
    result += '*'
  }

  return result
}
